import { Message } from 'element-ui'
import SuperagentApi from '../assets/utils/superagent'

const diyCodeServer = Wiz.globalSettings.globalConfig.diyCodeServer

export default class DiyCodeService {
  // 获取低代码分页数据
  static async getPipesData(data) {
    const formDataAPI = new SuperagentApi({ baseUrl: diyCodeServer })
    const [err, res] = await formDataAPI.post('/api/FormEngine/getTableData', {
      data,
      headers: {
        Authorization: `Bearer ${Wiz.AuthHooks.GetToken() ||
          localStorage.getItem('authorization')}`,
        'X-Wiz-Tenant-Id': JSON.parse(window.localStorage.getItem('CurrentUser'))?.TenantId || '',
      },
    })
    if (res.code !== 200) {
      res.Msg && Message.error(res.Msg)
    }
    return [err, res]
  }
}
